import { withFormik } from 'formik';
import { validation, required } from '../../../forms/util/validation';
import * as yup from 'yup';
var validationSchema = yup.object().shape({
  number: required('Order Number is required'),
  verificationValue: required('Verification info is required')
});
export var formikEnhancer = withFormik({
  enableReinitialize: false,
  validationSchema: validationSchema,
  handleSubmit: function handleSubmit(values, _ref) {
    var props = _ref.props;
    var data = {
      orderId: values.number,
      email: "",
      phoneNumber: "",
      zipCode: ""
    };
    data[values.verificationType] = values.verificationValue;
    props.postGuestOrderCheck(data); // props.setShowAddressForm(false);
    // props.setActiveAddress({});
  },
  displayName: 'Retail Guest Form' // helps with React DevTools

});